import createHangfirePoller from '@ancon/wildcat-utils/hangfire/createHangfirePoller'

import { buildCoreRequestHeaders } from '../../../api/client/Request'
import handleResponse from '../../../api/interceptors/handleResponse'
import handleHangfireResponseRejection from '../../../api/interceptors/handleHangfireResponseRejection'
import archiveLogger from '../../../utils/archiveLogger'
import isAppProduction from '../../app/utils/isAppProduction'

const enableLogging = false // Change to enable/disable logging

const hangfirePoller = createHangfirePoller({
  // A guest waits on the payment screen for the result, so poll often. The
  // BackgroundWorkerStatusEvent triggers a poll at once when the socket is up
  pollerInterval: 500,
  // A final result carries the check, so it can take longer than one poll
  // interval to arrive on a slow connection
  requestTimeout: 15000,
  responseInterceptor: handleResponse,
  responseRejectionInterceptor: handleHangfireResponseRejection,
  debug(...args: any[]) {
    if (!isAppProduction() && enableLogging) {
      // eslint-disable-next-line no-console
      console.log('[Hangfire]', ...args)
    }
  },
  getIsNetworkOnline: () =>
    typeof navigator === 'undefined' || navigator.onLine,
  // The poller has its own axios instance, so it does not get the default
  // headers of the Core client
  getRequestHeaders: buildCoreRequestHeaders,
  logger: archiveLogger,
})

export default hangfirePoller
